import { saveFile, saveJSON } from '@/util'

const Phone = {
  data(){
    return {
      data:''
    }
  },
  created(){
    this.$request.phone().then(resp => {
      this.data = resp.data.phone + `（${resp.data.name}）`
    })
  },
  render(){
    return <span>{this.data}</span>
  }
}

const Time = {
  props:{
    duration:{
      type:Number,
      default:60
    },
    interval:{
      type:Number,
      default:1
    }
  },
  data(){
    return {
      current:0,
      handler:null
    }
  },
  created(){

  },
  methods:{
    tick(){
      this.handler = window.setTimeout(()=>{
        this.current--
        if( this.current > 0 ){
          this.tick()
        }else{
          window.clearTimeout( this.handler )
        }
        
      },(this.interval || 1) * 1000)
    },
    handleClick(){
      this.current = this.duration

      this.tick()

      this.$emit('click')
    }
  },
  render(){
    if(this.current > 0){
      return <span>{this.current} S</span>
    }else{
      return <a on-click={this.handleClick}>{ this.$scopedSlots.default ? this.$scopedSlots.default() : '' }</a>
    }
     
  }
}

const SMSVerify = {
  name:'SmsVerify',
  props: ['params','api','sniff','beforeClose'],
  data() {
    return {
      loading: false,
      state: {
        verifyCode: null,
        uuid:null
      }
    }
  },
  created() {

  },
  methods: {
    handleExport() {
      if (!this.state.uuid) {
        this.$Message.error('请获取验证码')
        return
      }
      if (!this.state.verifyCode) {
        this.$Message.error('请输入验证码')
        return
      }

      let beforeClose = this.beforeClose

      if(this.api){
        let search = {}
        if(typeof this.params == 'function'){
          search = this.params(this.state)
        }else{
          search = Object.assign({},this.params || {} , this.state)
        }
        this.loading = true
        this.$request(this.api)(search).then(resp => {
          this.loading = false
          // raw 模式
          if( resp.headers ){
            let headers = resp.headers
            if(headers['content-type'] && headers['content-type'].includes('application/json')){
              saveJSON(resp.data).then(data => {
                this.$Message.error(data.msg)
              })
            }else {
              saveFile(resp)
              this.$emit('ok',resp)
            }
          }else{
            if( typeof beforeClose == 'function' ){
              let result = beforeClose(resp)
              if(result !== false){
                this.$emit('ok',resp)
              }
            }else{
              this.$emit('ok',resp)
            }
          }
          
        })
      }else{
        this.$emit('ok',{...this.state})
      }
      
    },
    handleSendCode() {
      let content
      if(typeof this.params == 'function'){
        content = this.params({})
      }else{
        content = this.params
      }
      this.$request.sms(content).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('短信验证码已发送，可能会有延后请耐心等待')
          this.state.uuid = resp.data
        } else {
          this.$Message.error(resp.msg)
        }
      })
    }
  },
  render() {
    const { loading } = this
    return (
      <div>
        <div class="modal-body">
          <sl-detail-list col={1} labelAlign="right" labelWidth="100px" style="padding:12px;">
            <sl-detail-list-item title="手机号"><Phone /></sl-detail-list-item>
            <sl-detail-list-item title="验证码" class="center">
              <div class="flex">
                <Input placeholder="手机验证码" v-model={this.state.verifyCode} />
                <Time style="flex:none; margin-left:24px;width:80px;" duration={60} on-click={this.handleSendCode}>获取验证码</Time>
              </div>
            </sl-detail-list-item>
          </sl-detail-list>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.handleExport} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}

const setSMSVerify = function(options = {}){
  return new Promise((resolve , reject) => {
    this.$dialog({
      title: options.title || '信息验证',
      width: 550,
      paddingless: true,
      render: (h) => {
        return <SMSVerify params={options.params} api={options.api} sniff={options.sniff} beforeClose={options.beforeClose} />
      },
      onOk(resp){
        resolve(resp.data)
      }
    })
  })
  
}

export default {
  install (Vue, options = {}) {
    Vue.prototype.$sms = setSMSVerify
    Vue.component(SMSVerify.name, SMSVerify)
  }
};
